import script from "./NameStep.vue?vue&type=script&setup=true&lang=js"
export * from "./NameStep.vue?vue&type=script&setup=true&lang=js"

import "./NameStep.vue?vue&type=style&index=0&id=5fe899c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fe899c0"]])

export default __exports__